export enum BodyPartTypeEnum {
  NOT_SET = "not_set",
}
